import { base64ToBlob } from './utils'
import qs from 'query-string'

const IMAGING_API_BASE_URL = 'https://imaging.giphy.com/imaging'

export default class Imaging {
    static concatenate = (srcUrls: string[], format: string = 'mp4', width?: number, height?: number) => {
        const srcParams = srcUrls.map((s) => 'src=' + encodeURIComponent(s)).join('&')

        let params = {
            fmt: format,
        }

        if (width) {
            params['width'] = width
        }
        if (height) {
            params['height'] = height
        }

        return `${IMAGING_API_BASE_URL}/concatenate?${srcParams}&${qs.stringify(params)}`
    }

    static trim = (srcUrl: string, start: number, duration: number, format: string = 'mp4') => {
        // Note: also supports height/width parameters (optional)
        return `${IMAGING_API_BASE_URL}/trim?media_url=${encodeURIComponent(
            srcUrl
        )}&start=${start}&duration=${duration}&fmt=${format}`
    }

    static crop = (srcUrl: string, x: number, y: number, width: number, height: number, format: string = 'mp4') => {
        // Note: also supports height/width parameters (optional)
        return `${IMAGING_API_BASE_URL}/crop?media_url=${encodeURIComponent(
            srcUrl
        )}&x=${x}&y=${y}&width=${width}&height=${height}&fmt=${format}`
    }

    static downsample = (srcUrl: string, fps: number, format: string = 'mp4', width?: number, height?: number) => {
        let params = {
            media_url: srcUrl,
            fps: fps,
            fmt: format,
        }

        if (width) {
            params['width'] = width
        }
        if (height) {
            params['height'] = height
        }

        return `${IMAGING_API_BASE_URL}/downsample?${qs.stringify(params)}`
    }

    static burnWatermark = async (srcUrl: string, watermarkData: string, format: string = 'mp4') => {
        const form = new FormData()
        form.append('media_url', srcUrl)
        form.append('file', base64ToBlob(watermarkData))
        form.append('upload', 'true')
        form.append('fmt', format)

        const response = await fetch(`${IMAGING_API_BASE_URL}/watermark`, {
            method: 'POST',
            body: form,
        })
        const data = await response.json()
        return data.url
    }
}
